/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { getCookie } from "./setGetCookie";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { sin } from "three/examples/jsm/nodes/Nodes.js";
gsap.registerPlugin(ScrollTrigger);

/**
 * 初期値
 */
let html = document.documentElement;
let splash = document.querySelector(".splash");
let header = document.querySelector("header .site-header");
let copyright = document.querySelector(".copyright");
let drawerButton = document.querySelector(".drawerButton");
let stalker = document.querySelector(".stalker");
let canvas = document.getElementById("canvas");
let mv_copy_jp = document.querySelectorAll(".mv .jp span");
let mv_copy_en = document.querySelector(".mv .en");
let mv_desc = document.querySelector(".mv .desc");
let mv_webservice = document.querySelectorAll(".mv .mv__service span");
let page_title_main = document.querySelector(".title .--main");
let page_section = document.querySelector(".index section");
let page_archive = document.querySelector(".archive .content-archive");
let post_article = document.querySelector(".single .container");
let archive_pagination = document.querySelector(".archive .content-pagination");
let single_mv = document.querySelector(".single .thumbnail img");
let single_mv_overlay = document.querySelector(".single .thumbnail .overlay");
let single_pagination = document.querySelector(".single .content-pagination");


/**
 * 処理
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    loadingAnimationInit();
    setTimeout(() => {
      loadingAnimation();
      hintBrowser();
    }, 1000);
  });
};

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __20:対象のクラスを削除
 */
function hintBrowser() {
  let willChangeItem = document.querySelectorAll(".hintBrowser");
  let alphaItem = document.querySelectorAll(".--alpha");
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("hintBrowser");
  }
  for (let i = 0; i < alphaItem.length; i++) {
    alphaItem[i].classList.remove("--alpha");
  }
}

/**
 * __30:ローディングアニメーション - 初期設定
 */
function loadingAnimationInit() {
  const init = () => {
    gsap.set([copyright, stalker], { autoAlpha: 0, });
    gsap.set([header], { y: header.clientHeight * -2, autoAlpha: 0, });
    gsap.set([drawerButton], { y: drawerButton.clientHeight * 2, autoAlpha: 0, });
  }

  const home = () => {
    gsap.set([mv_copy_jp], { y: mv_copy_jp[0].clientHeight * 0.25, backgroundSize: "100% 500%", autoAlpha: 0, })
    gsap.set([mv_copy_en], { y: mv_copy_en.clientHeight * 0.25, autoAlpha: 0, })
    gsap.set([mv_desc], { autoAlpha: 0, });
    gsap.set([mv_webservice], { y: mv_webservice[0].clientHeight * 0.25, autoAlpha: 0, });
    gsap.set([canvas], { autoAlpha: 0, });
  }

  const lower = () => {
    gsap.set([page_title_main], { y: page_title_main.clientHeight * 0.25, backgroundSize: "100% 500%", autoAlpha: 0, });
    gsap.set([page_section], { autoAlpha: 0, });
  }

  const archive = () => {
    gsap.set([page_title_main], { y: page_title_main.clientHeight * 0.25, backgroundSize: "100% 500%", autoAlpha: 0, });
    gsap.set([page_archive, archive_pagination], { autoAlpha: 0, });
  }

  const single = () => {
    gsap.set([post_article, single_mv_overlay, single_pagination], { autoAlpha: 0, });
    gsap.set([single_mv], { autoAlpha: 0, scale: 1.1, });
  }

  init();
  window.document.body.classList.contains("home") && home();
  window.document.body.classList.contains("page") && lower();
  window.document.body.classList.contains("archive") && archive();
  window.document.body.classList.contains("single") && single();
  window.document.body.classList.contains("error404") && lower();
}

/**
 * __40:ローディングアニメーション - 処理(初回読み込み時)
 */
function loadingAnimation() {
  let tl = gsap.timeline();
  let option = { duration: 2, ease: "power4.out" }
  const home = () => {
    tl.to(splash, { autoAlpha: 0, duration: 2, ease: "power4.out", delay: 1, onComplete: () => splash.remove(), }, 0) // スプラッシュ
      .to(canvas, { autoAlpha: 1, ...option }, 1) // キャンバス
      .to([header, drawerButton], { y: 0, autoAlpha: 1, duration: 1, ease: "power4.out" }, 2) // ヘッダー, ドロワーボタン
      .to([copyright, stalker], { autoAlpha: 1, duration: 1, ease: "power4.out" }, 2) // コピーライト, ストーカー
      .to(mv_copy_jp, { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 2) // キャッチコピー(日本語)
      .to(mv_copy_en, { y: 0, autoAlpha: 1, ...option }, 2.2) // キャッチコピー(英語)
      .to(mv_desc, { autoAlpha: 1, ...option }, 2.4) // キャッチコピー(説明)
      .to(mv_webservice, { y: 0, autoAlpha: 1, ...option, stagger: 0.2 }, 2) // キャッチコピー(サービス)
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 3); // ローディングアニメーション終了
  }

  const lower = () => {
    tl.to([header, drawerButton], { y: 0, autoAlpha: 1, ...option }, 0) // ヘッダー, ドロワーボタン
      .to([copyright, stalker], { autoAlpha: 1, ...option }, 0) // コピーライト, ストーカー.to([page_title_main], { y: 0, autoAlpha: 1, ...option }, 2) // タイトル(メイン)
      .to([page_title_main], { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 0.6) // タイトル(サブ)
      .to([page_section], { autoAlpha: 1, ...option }, 1) // セクション
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 1) // ローディングアニメーション終了
  }

  const archive = () => {
    tl.to([header, drawerButton], { y: 0, autoAlpha: 1, ...option }, 0) // ヘッダー, ドロワーボタン
      .to([copyright, stalker], { autoAlpha: 1, ...option }, 0) // コピーライト, ストーカー.to([page_title_main], { y: 0, autoAlpha: 1, ...option }, 2) // タイトル(メイン)
      .to([page_title_main], { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 0.6) // タイトル(サブ)
      .to([page_archive, archive_pagination], { autoAlpha: 1, ...option }, 1) // セクション
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 1) // ローディングアニメーション終了
  }

  const single = () => {
    tl.to([header, drawerButton], { y: 0, autoAlpha: 1, ...option }, 0) // ヘッダー, ドロワーボタン
      .to([copyright, stalker], { autoAlpha: 1, ...option }, 0) // コピーライト, ストーカー.to([page_title_main], { y: 0, autoAlpha: 1, ...option }, 2) // タイトル(メイン)
      .to([post_article, single_mv_overlay, single_pagination], { autoAlpha: 1, ...option }, 1) // セクション
      .to([single_mv], { autoAlpha: 1, scale: 1, ...option }, 1) // MV
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 1) // ローディングアニメーション終了
  }

  window.document.body.classList.contains("home") && home();
  window.document.body.classList.contains("page") && lower();
  window.document.body.classList.contains("single") && single();
  window.document.body.classList.contains("archive") && archive();
  window.document.body.classList.contains("error404") && lower();
}

/**
 * __50:ローディングアニメーション - 処理(リロード時)
 */
function loadingAnimationReload() {
  let option = { duration: 1, ease: "power4.out" }
  const init = () => {
    let tl = gsap.timeline();
    tl.to([header, drawerButton], { y: 0, autoAlpha: 1, ...option }, 0) // ヘッダー, ドロワーボタン
      .to([copyright, stalker], { autoAlpha: 1, ...option }, 0) // コピーライト, ストーカー
  }

  const home = () => {
    let tl = gsap.timeline();
    tl.to(splash, { autoAlpha: 0, ...option, onComplete: () => splash.remove(), }, 0) // スプラッシュ
      .to(canvas, { autoAlpha: 1, ...option }, 0) // キャンバス
      .to(mv_copy_jp, { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 0) // キャッチコピー(日本語)
      .to(mv_copy_en, { y: 0, autoAlpha: 1, ...option }, 0) // キャッチコピー(英語)
      .to(mv_desc, { autoAlpha: 1, ...option }, 0) // キャッチコピー(説明)
      .to(mv_webservice, { y: 0, autoAlpha: 1, ...option, stagger: 0.2 }, 0) // キャッチコピー(サービス)
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 1.2) // ローディングアニメーション終了
  }

  const lower = () => {
    let tl = gsap.timeline();
    tl.to([page_title_main], { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 0) // タイトル(メイン)
      .to([page_section], { autoAlpha: 1, ...option }, 0) // セクション
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 0) // ローディングアニメーション終了
  }

  const archive = () => {
    let tl = gsap.timeline();
    tl.to([page_title_main], { y: 0, backgroundSize: "100% 100%", autoAlpha: 1, ...option }, 0) // タイトル(メイン)
      .to([page_archive, archive_pagination], { autoAlpha: 1, ...option }, 0) // セクション
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 0) // ローディングアニメーション終了
  }

  single = () => {
    let tl = gsap.timeline();
    tl.to([post_article, single_mv_overlay, single_pagination], { autoAlpha: 1, ...option }, 0) // セクション
      .to([single_mv], { autoAlpha: 1, scale: 1, ...option }, 1) // セクション
      .to([html], { onComplete: () => html.classList.remove("--loading"), }, 0) // ローディングアニメーション終了
  }

  init();
  window.document.body.classList.contains("home") && home();
  window.document.body.classList.contains("page") && lower();
  window.document.body.classList.contains("single") && single();
  window.document.body.classList.contains("archive") && archive();
  window.document.body.classList.contains("error404") && lower();
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};